import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import OurSchool from './pages/OurSchool';
import AboutUs from './pages/AboutUs';
import MissionVision from './pages/MissionVision';
import History from './pages/History';
import PrincipalMessage from './pages/PrincipalMessage';
import OurBuildings from './pages/OurBuildings';
import Academics from './pages/Academics';
import LearningResources from './pages/LearningResources';
import Calendar from './pages/Calendar';
import Parents from './pages/Parents';
import Enrichment from './pages/Enrichment';
import Library from './pages/Library';
import Art from './pages/Art';
import Gym from './pages/Gym';
import PBIS from './pages/PBIS';
import Classes from './pages/Classes';
import Staff from './pages/Staff';
import TeacherLogin from './pages/TeacherLogin';
import Gallery from './pages/Gallery';
import CommunityEvents from './pages/CommunityEvents';
import MeetTheMascot from './pages/MeetTheMascot';
import AfterSchool from './pages/AfterSchool';
import routes from './routes.json';

// Route registry: maps the `component` name in routes.json to its imported
// component. This + routes.json are the single source of truth for routing
// (shared with scripts/prerender.mjs).
//
// To ADD a page: create the component, import it above, add it to this
// registry, and add a { path, component, title } entry to src/routes.json.
// To REMOVE a page: delete all four (component file, import, registry entry,
// routes.json entry).
const registry = {
  Home,
  OurSchool,
  AboutUs,
  MissionVision,
  History,
  PrincipalMessage,
  OurBuildings,
  Academics,
  LearningResources,
  Calendar,
  Parents,
  Enrichment,
  Library,
  Art,
  Gym,
  PBIS,
  Classes,
  Staff,
  TeacherLogin,
  Gallery,
  CommunityEvents,
  MeetTheMascot,
  AfterSchool,
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Router>
        <ScrollToTop />
        <Routes>
          {routes.map(({ path, component }) => {
            const C = registry[component];
            return C ? <Route key={path} path={path} element={<C />} /> : null;
          })}
        </Routes>
      </Router>
    </div>
  );
}

export default App;